import {
  CreateChatEditingSceneTaskDocument,
  GetChatEditingModelsDocument,
  GetChatEditingSceneDocument,
  ListChatEditingScenesDocument,
} from './generated/graphql'
import { createMutationHelper, createQueryHook, modifyQueryHook } from './utils'

export const useListChatEditingScenes = modifyQueryHook(
  createQueryHook(ListChatEditingScenesDocument),
  {
    reduce: r => r?.chatEditingScenes,
  },
)

export const useGetChatEditingScene = modifyQueryHook(
  createQueryHook(GetChatEditingSceneDocument),
  {
    transform: (sceneId: string) => ({ sceneId }),
    reduce: r => r?.chatEditingScene,
  },
)

export const useGetChatEditingModels = modifyQueryHook(
  createQueryHook(GetChatEditingModelsDocument),
  {
    reduce: r => r?.chatEditingModels,
  },
)

export const [
  useCreateChatEditingSceneTask,
  executeCreateChatEditingSceneTask,
] = createMutationHelper(CreateChatEditingSceneTaskDocument)
